import React from "react";
import { useDisplayOrderInd } from "./useDisplayOrderInd";
import { OrderIndData } from "../types";
import { useCopiedState } from "../../../../core/util/hooks";
import { Status } from "../../../models";
import { OrderSide } from "../../../models";

const now = new Date();

const defaultOrderInd: OrderIndData = {
  orderIndId: 0,
  description: "",
  parity: "",
  comment: "",
  side: OrderSide.Buy,
  productId: "",
  productCode: "",
  productName: "",
  creUser: "",
  creTime: now,
  employeeId: "",
  employeeName: "",
  status: 1,
  qty: 0,
};


export const useEditOrderInd = (orderid?: number): OrderIndData | undefined => {
  const displayOrderInd = useDisplayOrderInd(orderid);

  return React.useMemo(() => {
    if (orderid !== undefined && displayOrderInd === undefined) {
      return undefined;
    }

    if (orderid === undefined) {
      return { ...defaultOrderInd };
    }

    return displayOrderInd ? { ...displayOrderInd } : undefined;
  }, [orderid, displayOrderInd]);
};

export const useEditOrderIndState = (orderid?: number) => {
  const orderInd = useEditOrderInd(orderid);
  return useCopiedState(orderInd);
};
